import React from "react";
import Select from "./Select";

interface IsaacDropDownProps {
  constructionElementsName: string;
  constructionElementProperty: string;
  newValue: string | number | boolean | Record<string, unknown> | undefined;
  handleValueChanged: (value: string | undefined) => void;
  handleBlur: () => void;
  extraInfo?: { family: string };
}

const IsaacDropdown: React.FunctionComponent<IsaacDropDownProps> = ({
  constructionElementsName,
  constructionElementProperty,
  newValue,
  handleValueChanged,
  handleBlur,
  extraInfo,
}) => {
  return (
    <Select
      isDisabled={false}
      extraInfo={extraInfo}
      value={String(newValue ?? "")}
      constructionElementsName={constructionElementsName}
      property={constructionElementProperty}
      onValueChanged={handleValueChanged}
      onDropdownClosed={handleBlur}
    />
  );
};

export default IsaacDropdown;
